import message from "../../../messages/finance";

const validateAmount = (amount) => {
  if (amount < parseInt(process.env.REACT_APP_AT_LEAST_AMOUNT_CHARGE)) {
    return message.AMOUNT_IS_LESS;
  }

  return true;
};

const validateFormCharge = (amount) => {
  const resValidateAmount = validateAmount(amount);
  if (resValidateAmount != true) {
    return resValidateAmount;
  }

  return true;
};

export default validateFormCharge;
